import React, {
  useState,
  useEffect,
  createRef,
  useRef,
  useCallback,
} from "react";
import { Col } from "reactstrap";
import { Row } from "reactstrap";
import styles from "./../../../../Scheduler.module.scss";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import { encodeId, getStorage, isMobileTab } from "utils";
import * as moment from "moment";
import { useGetOfficeAgenda } from "repositories/scheduler-repository";
import { cloneDeep, findKey } from "lodash";
import constants from "../../../../../../../constants.js";
import { useHistory } from "react-router-dom";
import defautUserImage from "assets/images/staff-default.svg";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import HolidayImage from "assets/images/early_on.svg";
import crossIcon from "assets/images/cross.svg";
import MessageIcon from "assets/images/mail_icon.svg";
import CallIcon from "assets/images/call-icon.svg";
import Empty from "components/Empty";
import {
  MoreTagsFunction,
  renderOfficeNameOrEnterprise,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  filterEventsBySearch,
  filteringMethodForEventShiftOthers,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { leaveScreenEnabled } from "./MonthlyViewNew";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

function DailyViewNew({
  t,
  currentDate,
  selectedOwnerId,
  currentUserId,
  apiOffices,
  apiEmps,
  isSidebarActive,
  agendaTypes,
  cachedEventFilter,
  viewSettingFilter,
  isFromDashBoard,
  isEnterpriseFilterActive = false,
  searchValue = "",
  isfromLeaveDetailScreen,
  isFromLeaveDetail,
  canShowOfficeName,
}) {
  const {
    profile,
    isStaff,
    isOwner,
    dataAccessValues,
    effectiveOwnerIdString,
  } = useAccountOwnerCommon();

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );

  const history = useHistory();
  const calendarRef = createRef(null);
  const [dateRange, setDateRange] = useState(null);
  const [seeMoreUsers, setSeeMoreUsers] = useState([]);
  const [seeMoreOnCalender, setSeeMoreOnCalender] = useState("");
  const [hoverKey, setHoverKey] = useState("");
  const [hoverBusySlotKey, setHoverBusySlotKey] = useState("");
  const [agenda, setAgenda] = useState(null);
  const [agendaFilter, setAgendaFilter] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const nameRef = useRef(null);
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });

  const handlePopupToggle1 = (event, setter, hoverbusykey = "") => {
    event.stopPropagation();
    setHoverBusySlotKey(hoverbusykey);
    setHoverKey("");
    setInvitePopupPosition({
      top: 20,
      right: 0,
    });
    setter((prev) => !prev);
  };

  const handlePopupToggle = (userId) => {
    setPopupOpen((prev) => (prev === userId ? null : userId));
  };

  const filterByEvents = () => {
    const updatedAgenda = agenda?.map((item) => {
      const schedulerList = Array.isArray(item.officeSchedulerList)
        ? item.officeSchedulerList
        : [item.officeSchedulerList];

      const filteredSchedulerList = schedulerList.map((schedulerItem) =>
        filteringMethodForEventShiftOthers(
          agendaTypes,
          schedulerItem,
          currentUserId,
        ),
      );

      return {
        ...item,
        officeSchedulerList: filteredSchedulerList,
      };
    });
    setAgendaFilter(updatedAgenda);
  };

  useEffect(() => {
    if (cachedEventFilter?.length > 0) {
      filterByEvents();
    } else if (cachedEventFilter?.length === 0) {
      setAgendaFilter(agenda);
    }
  }, [agenda, cachedEventFilter]);

  useEffect(() => {
    if (currentDate) {
      setDateRange({
        startDate: moment(currentDate).format("YYYY-MM-DD"),
        endDate: moment(currentDate).format("YYYY-MM-DD"),
      });
    }
    if (isMobileTab() && isSidebarActive) {
      toast.success(t("accountOwner.dateApply"));
    }
    //eslint-disable-next-line
  }, [currentDate]);

  const enableFetch = selectedOwnerId && dateRange ? true : false;
  const {
    isLoading,
    isFetching,
    data: weeklyData,
    error,
  } = useGetOfficeAgenda(
    selectedOwnerId,
    dateRange?.startDate,
    dateRange?.endDate,
    apiOffices,
    apiEmps,
    { enabled: enableFetch },
  );

  useEffect(() => {
    if (!isLoading && weeklyData?.data) {
      const isFromLeaveDetail = getStorage("IsFromLeaveSchedule");
      const values = weeklyData?.data;
      if (isFromLeaveDetail?.userID) {
        const data = values?.map((intial) => {
          const check = intial?.officeSchedulerList?.findIndex(
            (res) => res?.user?.id === isFromLeaveDetail?.userID,
          );
          if (check !== -1) {
            const insert = { ...intial?.officeSchedulerList[check] };
            intial?.officeSchedulerList?.splice(check, 1);
            intial?.officeSchedulerList?.unshift(insert);
          }
          return {
            ...intial,
          };
        });
        setAgenda(data);
        setAgendaFilter(data);
      } else {
        setAgenda(weeklyData?.data);
        setAgendaFilter(weeklyData?.data);
      }
    }
  }, [isLoading, weeklyData]);

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
    //eslint-disable-next-line
  }, [error]);

  const resetHoverKey = (e) => {
    e.stopPropagation();
    setHoverKey("");
  };

  const getPopupData = (item, requestedDate) => {
    const data = {};
    data.title = item?.title || item?.reasonForBlock || null;
    data.officeName = renderOfficeNameOrEnterprise(item, t);
    data.patientFullName = item?.patientFullName || null;
    data.startTime = moment(item?.startTime).format("h:mm a");
    data.endTime = moment(item?.endTime).format("h:mm a");
    data.date = moment(requestedDate).format("MMM D, YYYY [-] ddd");
    const { agendaType } = item;
    switch (agendaType) {
      case constants.agendaType.EVENT: {
        const createdByOthers =
          item?.isShift && profile?.id !== item?.createdById;
        if (createdByOthers) {
          data.tag = t("scheduler.agenda.shiftByOthers");
        } else if (item?.isShift) {
          data.tag = t("scheduler.agenda.shiftTag");
        } else {
          data.tag = t("scheduler.agenda.eventTag");
        }
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        data.tag = t("scheduler.agenda.busyTag");
        break;
      }
      case constants.agendaType.BLOCKED: {
        data.tag = t("scheduler.agenda.busyTag");
        break;
      }
      case constants.agendaType.APPOINTMENT: {
        data.tag = t("scheduler.agenda.appointmentTag");
        data.title = t("scheduler.agenda.patient", {
          name: item.patientFullName,
        });
        data.isAppointment = true;
        const status = findKey(
          constants.appointmentStatus,
          (s) => s === item.appointmentStatus,
        );
        data.appointmentStatus = status
          ? t(`appointmentStatus.${status}`)
          : "--";
        break;
      }
      case constants.agendaType.LEAVE: {
        const { text } = leaveClasses(item?.statusId);
        data.tag = t(text);
        data.title = "";
        data.isLeave = true;
        break;
      }
      default: {
        break;
      }
    }
    return data;
  };

  const getPopupView = (
    item,
    backgroudColor,
    tagBackgroundColor,
    requestedDate,
    staffName,
  ) => {
    const data = getPopupData(item, requestedDate);
    return (
      <div className={styles["scheduler-popup-box"]}>
        <span className={styles["close-icon"]} onClick={resetHoverKey}>
          &times;
        </span>
        <div
          className={
            styles["scheduler-event-box"] + " " + styles[backgroudColor]
          }
        >
          <div
            className={styles["event-tag"] + " " + styles[tagBackgroundColor]}
          >
            {data.tag}
          </div>
          <div className={styles["event-type"]}>{data.title}</div>
          <Row className={styles.row}>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {constants.agendaType.APPOINTMENT === item.agendaType
                  ? t("scheduler.agenda.doctorName")
                  : t("scheduler.agenda.staffName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {staffName}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.officeName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.officeName}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.date")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.date}
              </Text>
            </Col>
            {!data.isLeave && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment
                    ? t("timeOfAppointment")
                    : t("staff.startTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.startTime}
                </Text>
              </Col>
            )}
            {!data.isLeave && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment ? t("status") : t("staff.endTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.isAppointment ? data?.appointmentStatus : data.endTime}
                </Text>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  };

  const goToDetails = (id, type, createdByMe, requestedDate) => {
    if (!id || !type) return;
    switch (type) {
      case constants.agendaType.EVENT: {
        let pathname = "/";
        pathname = createdByMe
          ? constants.routes.scheduler.eventDetails.replace(
              ":eventId",
              encodeId(id),
            )
          : constants.routes.scheduler.eventDetailsOnly.replace(
              ":eventId",
              encodeId(id),
            );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        const pathname = constants.routes.scheduler.busySlotDetail.replace(
          ":busySlotId",
          encodeId(id),
        );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      default: {
        return;
      }
    }
  };

  const getUsefulInfo = (item) => {
    const id = item?.id;
    const officeName = renderOfficeNameOrEnterprise(item, t);
    let title = item?.title || item?.reasonForBlock || null;
    title =
      title && title.length > constants.agendaTitleLength
        ? title.slice(0, constants.agendaTitleLength).concat(" ...")
        : title;
    const timezoneCode = item?.timezoneCode || null;
    const isAllDayEvent = item?.isAllDayEvent;
    const timeString = item?.isAllDayEvent
      ? t("scheduler.agenda.allDayEvent")
      : moment(item?.startTime).format("h:mm A") +
        " - " +
        moment(item?.endTime).format("h:mm A");
    //sepecific to Schedular events
    const createdByMe = item.createdById == currentUserId;
    const isInvite = !!item.eventEmployeeStatus;
    const status = item.eventStatus;
    const location = item?.location;
    let backgroudColorClass;
    backgroudColorClass =
      status === constants.SCHEDULERSTATUS.PENDING
        ? "color-blue"
        : createdByMe
          ? ""
          : "color-grey";

    let borderLeftClass = "";
    borderLeftClass =
      status === constants.SCHEDULERSTATUS.PENDING
        ? "border-left-blue"
        : createdByMe && status == constants.SCHEDULERSTATUS.ACCEPT
          ? "border-left-green"
          : "border-left-grey";

    return {
      officeName,
      title,
      timezoneCode,
      timeString,
      id,
      isAllDayEvent,
      createdByMe,
      isInvite,
      status,
      backgroudColorClass,
      borderLeftClass,
      location,
    };
  };

  const getAppointmentsView = (
    item,
    index,
    searchKey,
    requestedDate,
    staffName,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    return (
      <div
        key={index}
        className={`
                    ${styles["scheduler-event-box"]} ${styles["box-flex"]} ${styles["light-purple-bg"]}`}
        onClick={() => setHoverKey(thisHoverKey)}
      >
        <div className={`d-flex  ${styles["border-left-pink"]}`}>
          <div className={styles["event-tag"] + " " + styles["dark-grey-bg"]}>
            {t("scheduler.agenda.appointmentTag")}
          </div>
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>
              {data?.timeString}({data?.timezoneCode})
            </div>
          )}
          {canShowOfficeName &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"]}>{data.officeName}</div>
            )}
          {!viewSettingFilter.length && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("title")) && (
            <div className={styles["event-type"]}>
              {t("scheduler.agenda.appointmentTitle")}
            </div>
          )}
          {thisHoverKey === hoverKey &&
            getPopupView(
              item,
              "light-purple-bg",
              "dark-grey-bg",
              requestedDate,
              staffName,
            )}
        </div>
      </div>
    );
  };

  const getSchedulerEventsView = (
    item,
    index,
    searchKey,
    requestedDate,
    staffName,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    const createdByOthers = item?.isShift && profile?.id !== item?.createdById;

    return (
      <div
        key={index}
        className={`${styles["scheduler-event-box"]} ${styles["box-flex"]} ${
          styles[data.backgroudColorClass]
        } cursor-pointer`}
        onClick={() => {
          if (
            data.createdByMe ||
            (createdByOthers && canEditAndViewOthersData(item?.officeId))
          ) {
            goToDetails(
              data.id,
              constants.agendaType.EVENT,
              true,
              requestedDate,
            );
          } else {
            setHoverKey(thisHoverKey);
          }
        }}
      >
        <div className={`d-flex  pl-1 ${styles[data.borderLeftClass]}`}>
          <div className={styles["event-tag"] + " " + styles["theme-green-bg"]}>
            {createdByOthers
              ? t("scheduler.agenda.shiftByOthers")
              : item?.isShift
                ? t("scheduler.agenda.shiftTag")
                : t("scheduler.agenda.eventTag")}
          </div>
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>
              {data?.timeString}({data?.timezoneCode})
            </div>
          )}
          {canShowOfficeName &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"]}>{data.officeName}</div>
            )}
          {!viewSettingFilter.length && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}
          {(!viewSettingFilter.length || viewSettingFilter.includes("title")) &&
            (item?.isShift ? (
              viewSettingFilter.includes("title") && (
                <div className={styles["event-type"]}>
                  {data.title?.trim()
                    ? data.title
                    : t("scheduler.agenda.shiftTag")}
                </div>
              )
            ) : (
              <div className={styles["event-type"]}> {data.title} </div>
            ))}
          {thisHoverKey === hoverKey &&
            getPopupView(
              item,
              data.backgroudColorClass,
              "theme-green-bg",
              requestedDate,
              staffName,
            )}
        </div>
      </div>
    );
  };

  const getSchedulerBusySlotsView = (
    item,
    index,
    isSchedulerBusySlot,
    searchKey,
    requestedDate,
    staffName,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    const officeName = data?.officeName?.split(",")?.map((item) => {
      return {
        name: item,
        id: item,
      };
    });
    return (
      <div
        key={index}
        className={`
                    ${styles["scheduler-event-box"]} ${styles["box-flex"]} ${styles["light-orange-bg"]} cursor-pointer`}
        onClick={() => {
          if (data.createdByMe) {
            goToDetails(
              data.id,
              constants.agendaType.BUSY_SLOT,
              data.createdByMe,
              requestedDate,
            );
          } else {
            setHoverKey(thisHoverKey);
            setHoverBusySlotKey("");
          }
        }}
      >
        <div className={`d-flex pl-1  ${styles["border-left-yellow"]} `}>
          <div className={styles["event-tag"] + " " + styles["dark-orange-bg"]}>
            {t("scheduler.agenda.busyTag")}
          </div>
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>{data?.timeString}</div>
          )}
          {canShowOfficeName &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"] + " position-relative"}>
                <MoreTagsFunction
                  value={officeName || []}
                  lastIndex={2}
                  clickHandler={(e) =>
                    handlePopupToggle1(e, setNonInvitePopup, thisHoverKey)
                  }
                  mapFn={(member) => `${member?.name}`}
                />
                {thisHoverKey === hoverBusySlotKey && nonInvitePopup && (
                  <InviteesPopup
                    position={invitePopupPosition}
                    handleInvitePopupToggle={(e) =>
                      handlePopupToggle1(e, setNonInvitePopup)
                    }
                    list={officeName}
                    showRoleAndOffice={false}
                    isForEvent={true}
                    isfromBusySlot={true}
                    onlyOfffice
                  />
                )}
              </div>
            )}
          {!viewSettingFilter.length && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("title")) && (
            <div className={styles["event-type"]}> {data.title} </div>
          )}
          {thisHoverKey === hoverKey &&
            getPopupView(
              item,
              "light-orange-bg",
              "dark-orange-bg",
              requestedDate,
              staffName,
            )}
        </div>
      </div>
    );
  };

  const getLeavesView = (item, index, searchKey, requestedDate, staffName) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    const { Highlighter, borderLeft, main, text } = leaveClasses(
      item?.statusId,
    );

    return (
      <div
        key={index}
        className={`${styles["scheduler-event-box"]} ${styles["box-flex"]} ${styles[main]}`}
        onClick={() => setHoverKey(thisHoverKey)}
      >
        <div className={`d-flex  + ${styles[borderLeft]}`}>
          <div className={styles["event-tag"] + " " + styles[Highlighter]}>
            {t(text)}
          </div>

          {canShowOfficeName &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"]}>{data.officeName}</div>
            )}
          {!viewSettingFilter.length && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}
          {thisHoverKey === hoverKey &&
            getPopupView(item, main, Highlighter, requestedDate, staffName)}
        </div>
      </div>
    );
  };

  const shouldShowUserSeeMore = (data) => {
    return data.some((item) => {
      let {
        appointments,
        leaves,
        schedulerBusySlots,
        schedulerEvents,
        appointmentSlots,
      } = item;
      appointments = appointments || [];
      leaves = leaves || [];
      schedulerBusySlots = schedulerBusySlots || [];
      schedulerEvents = schedulerEvents || [];
      appointmentSlots = appointmentSlots || [];
      return (
        [
          appointments,
          leaves,
          schedulerBusySlots,
          schedulerEvents,
          appointmentSlots,
        ].flat().length > 2
      );
    });
  };

  const toggleSeeMoreForUserAndCalender = (userId) => {
    setSeeMoreUsers((state) =>
      state.includes(userId)
        ? state.filter((id) => id !== userId)
        : [...state, userId],
    );

    const allSearchKeys = [];
    if (userData && userData.length) {
      userData.forEach((ud) => {
        if (ud.user && ud.user.id === userId) {
          ud.data.forEach((_item) => {
            allSearchKeys.push(`${userId}_${_item.requestedDate}`);
          });
        }
      });
    }

    setSeeMoreOnCalender((prev) => {
      if (allSearchKeys.some((key) => prev.includes(key))) {
        let newVal = prev;
        allSearchKeys.forEach((key) => {
          newVal = newVal.replace(key, "");
        });
        return newVal;
      } else {
        return prev + allSearchKeys.join("");
      }
    });
  };

  const getDifferentEvents = (events) => {
    return (events || []).reduce(
      (acc, item) => {
        const { isAllDayEvent } = item;
        if (isAllDayEvent) {
          acc[0].push(item);
        } else {
          acc[1].push(item);
        }
        return acc;
      },
      [[], []],
    );
  };

  let userData = [];
  let tableJsx = null;
  let holidayRowJsx = null;
  let filteredAgendaFilter = agendaFilter;

  if (
    typeof isEnterpriseFilterActive !== "undefined" &&
    isEnterpriseFilterActive
  ) {
    filteredAgendaFilter = (agendaFilter || []).map((date) => {
      const filteredOfficeSchedulerList = (date.officeSchedulerList || []).map(
        (item) => ({
          ...item,
          appointments: (item.appointments || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          leaves: (item.leaves || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerBusySlots: (item.schedulerBusySlots || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerEvents: (item.schedulerEvents || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          appointmentSlots: (item.appointmentSlots || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
        }),
      );
      return {
        ...date,
        officeSchedulerList: filteredOfficeSchedulerList,
      };
    });
  } else {
    filteredAgendaFilter = agendaFilter;
  }

  if (filteredAgendaFilter?.length) {
    userData = cloneDeep(filteredAgendaFilter?.[0].officeSchedulerList).map(
      (item) => ({
        user: item.user,
        data: [],
      }),
    );

    filteredAgendaFilter?.forEach((date) => {
      const { requestedDate, officeSchedulerList, holidayList } = date;
      officeSchedulerList.forEach((data, userIndex) => {
        const { user, ...rest } = data;
        userData[userIndex].data.push({ requestedDate, holidayList, ...rest });
      });
    });

    tableJsx =
      userData?.length &&
      userData?.map((ud, ui) => {
        const { user, data } = ud;
        const {
          fullName,
          profilePic,
          id: userId,
          emailId,
          designationNames,
          contactNumber,
          officeNames,
        } = user || {};
        const isSeeLessVisible = seeMoreUsers.includes(userId);
        return (
          <tr key={ui}>
            <th
              className={isFromDashBoard ? styles.th_dashboard : ""}
              style={
                isFromDashBoard
                  ? {
                      maxWidth: "150px",
                      minWidth: "150px",
                      borderLeft: "none",
                    }
                  : {}
              }
            >
              <div className={styles["scheduler-client-box"]}>
                <div
                  className={styles["client-img"]}
                  onClick={() => handlePopupToggle(userId)}
                >
                  <img
                    src={profilePic || defautUserImage}
                    alt="icon"
                    onError={(e) => {
                      e.currentTarget.src = defautUserImage;
                    }}
                  />
                </div>
                <div
                  className={styles["client-name"]}
                  ref={nameRef}
                  onClick={() => handlePopupToggle(userId)}
                >
                  {fullName}
                </div>
                {shouldShowUserSeeMore(data) && (
                  <div
                    className={styles["see-btn"]}
                    onClick={() => toggleSeeMoreForUserAndCalender(userId)}
                  >
                    <span>
                      {isSeeLessVisible
                        ? t("scheduler.agenda.seeLess")
                        : t("scheduler.agenda.seeMore")}
                    </span>
                    <img
                      className={
                        isSeeLessVisible ? styles["rotate-caret-icon"] : ""
                      }
                      src={require("assets/images/caret-587E85.svg").default}
                      alt="caret"
                    />
                  </div>
                )}

                {popupOpen === userId && (
                  <div className={styles.schedular_popup_daily_view}>
                    <span
                      className={styles.close_btn}
                      onClick={() => handlePopupToggle(userId)}
                    >
                      <img src={crossIcon} alt="close" />
                    </span>
                    <div className={styles.content_wrapper}>
                      <div className={styles.client_img}>
                        <img src={profilePic || defautUserImage} alt="icon" />
                      </div>
                      <Text
                        size="14px"
                        weight="600"
                        color="#587E85"
                        marginTop="6px"
                      >
                        {fullName}
                      </Text>
                      <Text size="12px" weight="500" color="#87928D">
                        {designationNames?.map(
                          (designationName) => designationName,
                        )}
                      </Text>
                      <Text size="12px" weight="500" color="#2A4642">
                        {officeNames?.join(", ")}
                      </Text>
                      <div className={styles.email_number}>
                        <div className={styles.wrap_cont}>
                          <img src={MessageIcon} alt="CallIcon" />
                          <Text size="12px" weight="500" color="#587E85" break>
                            {emailId}
                          </Text>
                        </div>
                        <div className={styles.wrap_cont}>
                          <img
                            src={CallIcon}
                            alt="CallIcon"
                            className={styles.call_icon_new}
                          />
                          <Text size="12px" weight="500" color="#587E85">
                            {contactNumber}
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </th>
            {data.map((_item) => {
              const {
                requestedDate,
                appointments,
                leaves,
                schedulerBusySlots,
                schedulerEvents,
                appointmentSlots,
                holidayList,
              } = _item;

              const [allDayEvents, allOtherEvents] = getDifferentEvents(
                schedulerEvents || [],
              );
              let allItems = [
                appointments || [],
                schedulerBusySlots || [],
                allOtherEvents || [],
                appointmentSlots || [],
              ]
                .flat()
                .sort((a, b) => {
                  if (
                    moment(
                      moment(b.startTime).format("HH:mm"),
                      "HH:mm",
                    ).isAfter(
                      moment(moment(a.startTime).format("HH:mm"), "HH:mm"),
                    )
                  ) {
                    return -1;
                  } else {
                    return 1;
                  }
                });
              allItems = [...(leaves || []), ...allDayEvents, ...allItems];
              // Apply search filter here
              allItems = filterEventsBySearch(allItems, user, searchValue);
              let slicedItems = [...allItems];
              const showSeeMore = isFromDashBoard
                ? allItems.length > 2
                : allItems.length > 3;
              const searchKey = `${userId}_${requestedDate}`;

              if (!seeMoreUsers.includes(userId)) {
                slicedItems = isFromDashBoard
                  ? allItems.slice(0, 2)
                  : allItems.slice(0, 3);
              }
              if (
                !seeMoreUsers.includes(userId) &&
                seeMoreOnCalender.includes(searchKey)
              ) {
                slicedItems = [...allItems];
              }
              const leaveClassFromDetail = leaveScreenEnabled({
                isfromLeaveDetailScreen,
                isFromLeaveDetail,
                requestedMomentDate: moment(requestedDate),
              });
              return (
                <td
                  key={requestedDate}
                  className={`${
                    leaveClassFromDetail && userId === isFromLeaveDetail?.userID
                      ? leaveClassFromDetail
                      : holidayList?.length > 0 && styles["light-red-bg"]
                  } w-100`}
                >
                  {slicedItems.map((item, index) => {
                    const { agendaType } = item;
                    switch (agendaType) {
                      case constants.agendaType.EVENT: {
                        return getSchedulerEventsView(
                          item,
                          index,
                          searchKey,
                          requestedDate,
                          fullName,
                        );
                      }
                      case constants.agendaType.BUSY_SLOT:
                      case constants.agendaType.BLOCKED: {
                        return getSchedulerBusySlotsView(
                          item,
                          index,
                          agendaType === constants.agendaType.BUSY_SLOT,
                          searchKey,
                          requestedDate,
                          fullName,
                        );
                      }
                      case constants.agendaType.APPOINTMENT: {
                        return getAppointmentsView(
                          item,
                          index,
                          searchKey,
                          requestedDate,
                          fullName,
                        );
                      }
                      case constants.agendaType.LEAVE: {
                        return getLeavesView(
                          item,
                          index,
                          searchKey,
                          requestedDate,
                          fullName,
                        );
                      }
                      default: {
                        return null;
                      }
                    }
                  })}
                  {showSeeMore && (
                    <div className={styles["more-event-box"]}>
                      <span
                        className={styles["more-event-btn"]}
                        onClick={() => toggleSeeMoreForUserAndCalender(userId)}
                      >
                        {seeMoreUsers.includes(userId)
                          ? t("scheduler.agenda.seeLess")
                          : t("scheduler.agenda.seeMoreWithCount", {
                              count: isFromDashBoard
                                ? allItems.length - 2
                                : allItems.length - 3,
                            })}
                      </span>
                    </div>
                  )}
                </td>
              );
            })}
          </tr>
        );
      });

    holidayRowJsx = (
      <tr>
        {[{}, ...filteredAgendaFilter].map((date, index) => {
          if (index === 0) {
            return (
              <td
                key={`holiday-${index}`}
                style={isFromDashBoard ? { borderLeft: "none" } : {}}
              ></td>
            );
          }
          const adjustedIndex = index - 1;
          const validIndex = filteredAgendaFilter[adjustedIndex];

          const holidayList = validIndex
            ? filteredAgendaFilter[adjustedIndex].holidayList
            : null;

          if (
            holidayList?.length > 0 &&
            validIndex?.requestedDate === holidayList?.[0]?.date
          ) {
            return (
              <td key={`holiday-${index}`} className={styles["holiday-cell"]}>
                <div className={styles["holiday_title"]}>
                  <img
                    src={HolidayImage}
                    alt="holiday"
                    className="account_owner_image"
                  />

                  <div className={styles.holiday_title_text}>
                    {holidayList?.[0]?.title}
                  </div>
                </div>
              </td>
            );
          }
          return (
            <td
              key={`holiday-${index}`}
              style={isFromDashBoard ? { borderLeft: "none" } : {}}
            ></td>
          );
        })}
      </tr>
    );
  }

  return (
    <div
      className={`table-card-border `}
      style={isFromDashBoard ? { border: "none" } : {}}
    >
      {isLoading && <Loader />}
      <div className={styles["scheduler-table-wrapper"]}>
        <div
          ref={calendarRef}
          className={
            isFromDashBoard
              ? styles["scheduler-fixed-table-new"]
              : styles["scheduler-fixed-table"]
          }
        >
          <table
            className={`table table-bordered ${styles["schedular-table"]} ${
              styles["staff-weekly-table"]
            }  ${weeklyData?.data?.length === 0 ? "no-border" : " "} `}
            style={isFromDashBoard ? { borderLeft: "none" } : {}}
          >
            <tbody>
              {holidayRowJsx}
              {weeklyData?.data?.length > 0 ? (
                tableJsx
              ) : (
                <tr>
                  <td colSpan={userData?.length || 1} className="w-100">
                    <Empty Message={t("scheduler.noEventsFound")} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(DailyViewNew);
